import React from 'react';
import { FaInstagram, FaEnvelope, FaLinkedin, FaGithub } from "react-icons/fa";

const Footer = () => {
    return (
        <div className='bg-black text-center text-lg-left'>
            <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
                <span className="text-gray-400">
                    &copy; {new Date().getFullYear()} Made By:{' '}
                </span>
                <a 
                    href="https://situdio.vercel.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg text-purple-400 font-light hover:underline ml-1"
                >
                    @situdio.id
                </a>
                <span className="text-gray-400 mx-1 font-bold"> -</span>
                <a 
                    href="https://www.linkedin.com/in/aminiqbaal/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg text-purple-400 font-light hover:underline ml-1"
                >
                    Muhammad Amin Iqbaal Alam, S.Kom
                </a>
            </div>
        </div>
    );
};

export default Footer;